import React, { useEffect, useState } from "react";
import * as _ from "lodash";
import {
  Table,
  Button,
  Form,
  Tabs,
  Tab,
  ButtonGroup,
  Row,
  Modal,
} from "react-bootstrap";
import AnimationLoading from "../../../components/AnimationLoading";
import { useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment";
import Switch from "react-switch";
import { useToasts } from "react-toast-notifications";
import { GET_POST_STOCKS } from "../../../graphql/postStock/query";
import { imageRender } from "../../../helpers";
import { COLOR_APP } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faExclamationCircle,
  faPlus,
  faSave,
  faTimes,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import NumberFormat from "react-number-format";
import { GET_STOCKS } from "../../../graphql/stock/query";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import { CLEAR_CACHE_LIVE_STOCK_REDIS } from "../../../graphql/liveStock/mutation";
import {
  CREATE_POST_STOCK,
  DELETE_POST_STOCK,
  UPDATE_POST_STOCK,
} from "../../../graphql/postStock/mutation";
import { CREATE_PRODUCT_AND_STOCKS } from "../../../graphql/product/mutation";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import ReactPaginate from "react-paginate";

function LiveDetailPostProduct({ liveData, postStocks, setPostStocks }) {
  const { height, width } = useWindowDimensions();
  const LIMIT_PAGE = 30;
  const { addToast } = useToasts();
  // const [postStocks, setPostStocks] = useState([]);
  const [displayPostStocks, setDisplayPostStocks] = useState([]);
  const [postStocksTotal, setPostStocksTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [editIndex, setEditIndex] = useState(null);

  const [amountAll, setAmountAll] = useState(null);

  const [showAddStock, setShowAddStock] = useState(false);
  const [isAlreadyExist, setIsAlreadyExist] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState({});

  const [currency, setCurrency] = useState("ກີບ");
  const [cfMessage, setCfMessage] = useState("");
  const [productTital, setProductTital] = useState("");
  const [stockPriceLak, setStockPriceLak] = useState(null);
  const [stockAmount, setStockAmount] = useState(null);

  const [selectedAddOption, setSeletedAddOption] = useState("");
  const [selectedStock, setSeletedStock] = useState({});
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [stocksData, setStocksData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page in the pagination
  const [stocksPerPage] = useState(50); // Number of stocks per page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages

  //* ຊ່ອງຄົ້ນຫາສິນຄ້າໃນສາງ (ຢູ່ໃນ modal ເພີ່ມສິນຄ້າ)
  //* ແຍກຈາກ searchKeyWord ຂອງຕາຕະລາງ ບໍ່ດັ່ງນັ້ນການພິມໃນ modal ຈະໄປກັ່ນຕອງຕາຕະລາງນຳ
  const [stockKeyWord, setStockKeyWord] = useState("");
  //* ລາຍການທີ່ເລືອກໄວ້ຈະເພີ່ມ — ເລືອກໄດ້ຫຼາຍໂຕພ້ອມກັນ
  //* ແຕ່ລະແຖວ: { stock, amount, cfMessage } — ລະຫັດ CF ແກ້ໄດ້ ເພາະບາງໂຕໃນສາງຍັງບໍ່ມີ
  const [addRows, setAddRows] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  // const [getPostStocks, { data: postStockData }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getStocks, { data: stockData, loading: stockLoading }] = useLazyQuery(
    GET_STOCKS,
    { fetchPolicy: "cache-and-network" },
  );
  //* ຕົວແຍກສຳລັບຫາ stock ທີ່ຫາກໍສ້າງ — ໃຊ້ getStocks ຕົວເກົ່າຈະໄປລ້າງລາຍການຄົ້ນຫາໃນ modal
  const [findStockByCf] = useLazyQuery(GET_STOCKS, {
    fetchPolicy: "network-only",
  });
  const [clearCacheLiveStockRedis] = useMutation(CLEAR_CACHE_LIVE_STOCK_REDIS);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [createPostStock] = useMutation(CREATE_POST_STOCK);
  const [updatePostStock] = useMutation(UPDATE_POST_STOCK);
  const [deletePostStock] = useMutation(DELETE_POST_STOCK);
  const [createProductAndStocks] = useMutation(CREATE_PRODUCT_AND_STOCKS);

  useEffect(() => {
    if (liveData?.id) {
      fetch();
    }
  }, [liveData]);

  useEffect(() => {
    if (postStocks?.length > 0) fetch();
  }, [searchKeyWord, pageNumber, JSON.stringify(postStocks)]);

  useEffect(() => {
    // Fetch all live stock data
    const fetchData = async () => {
      // Replace this with your actual data fetching logic
      setTotalPages(Math.ceil(displayPostStocks.length / stocksPerPage));
    };

    if (displayPostStocks?.length > 0) fetchData();
  }, [displayPostStocks]);

  const fetch = async () => {
    try {
      // let _where = {
      //     post: liveData?.id,
      //     isDeleted: false
      // };

      // if (searchKeyWord != '') _where = { ..._where, 'stock.name': searchKeyWord, cfMessage: searchKeyWord }
      // console.log({ _where })
      const _newPostStocks = postStocks?.filter(({ cfMessage, stock }) => {
        return (
          cfMessage?.toLowerCase().includes(searchKeyWord?.toLowerCase()) ||
          stock?.name?.toLowerCase().includes(searchKeyWord?.toLowerCase())
        );
      });
      setDisplayPostStocks(_newPostStocks);
    } catch (err) {
      console.log({ err });
    }
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1); // Since `ReactPaginate` is zero-indexed
  };

  //* ໂຫຼດລາຍການສິນຄ້າໃນສາງເມື່ອເປີດ modal ຫຼື ພິມຄົ້ນຫາ (ຖ່ວງເວລາ 500ms ກັນຍິງຖີ່)
  useEffect(() => {
    if (!showAddStock || selectedAddOption !== "ON_STOCK") return;
    const _timer = setTimeout(() => fetchStocks(stockKeyWord), 500);
    return () => clearTimeout(_timer);
  }, [showAddStock, selectedAddOption, stockKeyWord]);

  useEffect(() => {
    setStocksData(stockData?.stocks?.data ?? []);
  }, [stockData]);

  const fetchStocks = async (keyword) => {
    try {
      const SHOP_ID = await localStorage.getItem("SHOP");
      let _where = { isDeleted: false, shop: SHOP_ID };
      const _key = (keyword ?? "").trim();
      //* ໃຊ້ຮູບແບບ OR ຄືກັນກັບໜ້າສ້າງໂພສ ຈະໄດ້ຮັບປະກັນວ່າໃຊ້ໄດ້ກັບ API ໂຕປັດຈຸບັນ
      if (_key) {
        _where.OR = [
          { name: _key },
          { cfMessage: _key },
          { name: _key.toLowerCase() },
          { cfMessage: _key.toLowerCase() },
          { name: _key.toUpperCase() },
          { cfMessage: _key.toUpperCase() },
        ];
      }
      await getStocks({
        variables: {
          where: _where,
          limit: 50,
          skip: 0,
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("fetchStocks error:", error);
    }
  };

  //* ຮູບແບບດຽວກັນກັບທີ່ຫຼັງບ້ານໃຊ້ທຽບ: ຕົວພິມໃຫຍ່ + ຕັດຊ່ອງວ່າງ
  const normalizeCf = (value) =>
    (value ?? "").toString().trim().replace(/\s+/g, "").toUpperCase();

  //* ກວດລະຫັດ CF ກ່ອນເພີ່ມ
  //*
  //* ຫຼັງບ້ານທຽບລະຫັດດ້ວຍ cfCode ຖ້າຊ້ຳກັນ ອໍເດີຈະໄປລົງສິນຄ້າຜິດໂຕ
  //* ສ່ວນລະຫັດທີ່ເປັນຄຳນຳໜ້າຂອງກັນ (A1 ກັບ A11) ຍັງເພີ່ມໄດ້ ແຕ່ເຕືອນໄວ້ກ່ອນ
  const checkCfCode = (code) => {
    const _code = normalizeCf(code);
    if (!_code) return { error: "ກະລຸນາປ້ອນລະຫັດ CF" };

    const _duplicated = (postStocks ?? []).find(
      (item) => normalizeCf(item?.cfMessage) === _code,
    );
    if (_duplicated) return { error: "ລະຫັດ CF ນີ້ມີຢູ່ໃນໂພສນີ້ແລ້ວ" };

    const _near = (postStocks ?? []).find((item) => {
      const _other = normalizeCf(item?.cfMessage);
      return _other && (_other.startsWith(_code) || _code.startsWith(_other));
    });
    if (_near) {
      return {
        warning: "ລະຫັດຄ້າຍກັບ " + _near?.cfMessage + " ອາດຈັບ CF ຜິດໂຕ",
      };
    }
    return {};
  };

  //* ລ້າງ cache ລາຍການສິນຄ້າຂອງໂພສ
  //*
  //* ຕົວປະມວນຜົນຄອມເມັນອ່ານລາຍການສິນຄ້າຈາກ redis (ອາຍຸ 5 ຊົ່ວໂມງ) ຖ້າບໍ່ລ້າງ
  //* ສິນຄ້າທີ່ຫາກໍເພີ່ມຈະ CF ບໍ່ຕິດຈົນກວ່າ cache ໝົດອາຍຸ
  //*
  //* ຖ້າ API ເປັນບິວເກົ່າທີ່ຍັງບໍ່ມີ mutation ນີ້ ຈຶ່ງຖອຍໄປໃຊ້ updatePostStock ແທນ
  //* ເພາະ resolver ນັ້ນລ້າງ cache ໃຫ້ຄືກັນ ແລະ ມີມາດົນແລ້ວ
  const clearPostStockCache = async (postStockId) => {
    try {
      await clearCacheLiveStockRedis({ variables: { liveId: liveData?.id } });
      return;
    } catch (error) {
      console.log("clearCacheLiveStockRedis failed, use fallback:", error);
    }
    try {
      if (postStockId) {
        await updatePostStock({
          variables: {
            where: { id: postStockId },
            data: { isPublished: true },
          },
        });
      }
    } catch (error) {
      console.log("fallback clear cache failed:", error);
    }
  };

  //* ຕິກ/ຖອນຕິກສິນຄ້າໜຶ່ງໂຕໃນລາຍການສາງ
  const toggleStockRow = (item) => {
    setAddRows((prev) => {
      const _exist = (prev ?? []).some((row) => row?.stock?.id === item?.id);
      if (_exist) return prev.filter((row) => row?.stock?.id !== item?.id);
      return [
        ...prev,
        {
          stock: item,
          amount: (item?.amount ?? 0).toString(),
          cfMessage: item?.cfMessage ?? "",
        },
      ];
    });
  };

  const updateAddRow = (stockId, patch) => {
    setAddRows((prev) =>
      (prev ?? []).map((row) =>
        row?.stock?.id === stockId ? { ...row, ...patch } : row,
      ),
    );
  };

  const resetAddForm = () => {
    setSeletedAddOption("");
    setSeletedStock({});
    setStockKeyWord("");
    setAddRows([]);
    setCfMessage("");
    setProductTital("");
    setStockPriceLak(null);
    setStockAmount(null);
    setIsAlreadyExist(false);
  };

  //* ຕໍ່ແຖວໃໝ່ໃສ່ຕາຕະລາງທັນທີ ບໍ່ຕ້ອງ reload ໜ້າ
  //*
  //* optionValues ຕ້ອງມີສະເໝີ ເພາະຕາຕະລາງອ່ານ .length ໂດຍບໍ່ໄດ້ກັນ undefined
  const appendPostStocks = (items) => {
    try {
      setPostStocks([...(items ?? []), ...(postStocks ?? [])]);
    } catch (error) {
      console.log("append post stock failed:", error);
    }
  };

  const onSelectStock = async (e) => {
    const checkStock = stocksData.filter((stock) =>
      e?.target?.value.trim().split("ລະຫັດ: ")[0] != ""
        ? stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[0]
        : stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[1],
    );
    if (checkStock.length > 0) {
      setSeletedStock(checkStock[0]);
      const checkCfMessage = postStocks.filter(
        (item) => item.cfMessage == checkStock[0]?.cfMessage,
      );
      if (checkCfMessage.length > 0) setIsAlreadyExist(true);
      else setIsAlreadyExist(false);
    } else {
      setSeletedStock(null);
    }
  };

  //* ເພີ່ມສິນຄ້າເຂົ້າໂພສເດີມ — ບໍ່ຕ້ອງສ້າງໂພສໃໝ່ ແລະ ບໍ່ຕ້ອງປິດ-ເປີດໂພສຄືນ
  //*
  //* 3 ຢ່າງທີ່ຂາດບໍ່ໄດ້ ບໍ່ດັ່ງນັ້ນລູກຄ້າ CF ແລ້ວຈະບໍ່ຕິດ:
  //*   1. cfCode — ຫຼັງບ້ານທຽບລະຫັດດ້ວຍ cfCode ບໍ່ແມ່ນ cfMessage
  //*   2. ສາງກາງຕ້ອງມີຂອງ >= ຈຳນວນທີ່ປັກຂາຍ ເພາະຕອນ CF ຕັດທັງ postStock ແລະ stock
  //*   3. ລ້າງ redis cache ຫຼັງເພີ່ມ
  const onAddStock = async () => {
    if (isSaving) return;
    try {
      const SHOP_ID = await localStorage.getItem("SHOP");

      //* ---- ເລືອກຈາກສິນຄ້າທີ່ມີໃນສາງ (ເລືອກໄດ້ຫຼາຍໂຕພ້ອມກັນ) ----
      if (selectedAddOption === "ON_STOCK") {
        if ((addRows ?? []).length === 0) {
          addToast("ກະລຸນາເລືອກສິນຄ້າກ່ອນ", {
            appearance: "warning",
            autoDismiss: true,
          });
          return;
        }

        //* ກວດທຸກແຖວໃຫ້ຜ່ານກ່ອນ ຈຶ່ງຄ່ອຍຍິງ API
        //* ຖ້າກວດໄປເພີ່ມໄປ ຈະເພີ່ມສຳເລັດເຄິ່ງໜຶ່ງແລ້ວຄ້າງ ຊຶ່ງແກ້ຄືນຍາກ
        const _rows = [];
        const _warnings = [];
        const _seen = [];
        for (const row of addRows) {
          const _name = row?.stock?.name ?? "-";
          const _code = (row?.cfMessage ?? "").trim();

          const _check = checkCfCode(_code);
          if (_check.error) {
            addToast(_name + ": " + _check.error, {
              appearance: "error",
              autoDismiss: true,
            });
            return;
          }
          if (_seen.includes(normalizeCf(_code))) {
            addToast("ລະຫັດ CF " + _code + " ຊ້ຳກັນໃນລາຍການທີ່ເລືອກ", {
              appearance: "error",
              autoDismiss: true,
            });
            return;
          }
          _seen.push(normalizeCf(_code));

          const _amount =
            parseInt((row?.amount ?? "").toString().replace(/,/g, "")) || 0;
          if (_amount <= 0) {
            addToast(_name + ": ກະລຸນາປ້ອນຈຳນວນທີ່ຈະຂາຍໃນໂພສ", {
              appearance: "warning",
              autoDismiss: true,
            });
            return;
          }
          //* ກັນໄວ້ອີກຊັ້ນ ເຜື່ອຂອງໃນສາງຫຼຸດລົງລະຫວ່າງທີ່ modal ເປີດຄ້າງໄວ້
          if (_amount > (row?.stock?.amount ?? 0)) {
            addToast(_name + ": ມີພຽງ " + thousand(row?.stock?.amount ?? 0), {
              appearance: "warning",
              autoDismiss: true,
            });
            return;
          }

          if (_check.warning) _warnings.push(_check.warning);
          _rows.push({ stock: row?.stock, code: _code, amount: _amount });
        }

        setIsSaving(true);
        setIsLoading(true);

        const _added = [];
        const _failed = [];
        for (const row of _rows) {
          //* ຫຸ້ມ try ເປັນລາຍໂຕ — ໂຕໃດໜຶ່ງຫຼົ້ມ ບໍ່ຄວນເຮັດໃຫ້ໂຕທີ່ເພີ່ມສຳເລັດແລ້ວ
          //* ຄ້າງໂດຍບໍ່ໄດ້ລ້າງ cache (ຈະກາຍເປັນ CF ບໍ່ຕິດແບບຫາສາເຫດຍາກ)
          try {
            //* ຕາໜ່າງກັນຊັ້ນສຸດທ້າຍ ປົກກະຕິບໍ່ເຂົ້າເງື່ອນໄຂນີ້
            //* ເພາະຊ່ອງປ້ອນຈຳກັດບໍ່ໃຫ້ເກີນຂອງທີ່ມີໃນສາງຢູ່ແລ້ວ
            //*
            //* ຖ້າມີໂຕໃດຫຼຸດມາໄດ້ ຕ້ອງເຕີມສາງກາງກ່ອນ ບໍ່ດັ່ງນັ້ນ CF ຈະຈັບລະຫັດໄດ້
            //* ແຕ່ຕັດສະຕັອກບໍ່ຜ່ານ ແລ້ວອໍເດີຈະຫຼຸດ
            if ((row?.stock?.amount ?? 0) < row?.amount) {
              await updateStock({
                variables: {
                  where: { id: row?.stock?.id },
                  data: { amount: row?.amount },
                },
              });
            }

            const _created = await createPostStock({
              variables: {
                data: {
                  amount: row?.amount,
                  amountAll: row?.amount,
                  cfMessage: row?.code,
                  cfCode: row?.code.toUpperCase(),
                  stock: row?.stock?.id,
                  post: liveData?.id,
                  fbFeedId: liveData?.fbFeedId,
                  isPublished: true,
                  isDeleted: false,
                  shop: SHOP_ID,
                },
              },
            });

            _added.push({
              id: _created?.data?.createPostStock?.id,
              amount: row?.amount,
              amountAll: row?.amount,
              cfMessage: row?.code,
              isPublished: true,
              createdAt: new Date(),
              fbFeedId: liveData?.fbFeedId,
              stock: {
                id: row?.stock?.id,
                name: row?.stock?.name,
                amount: Math.max(row?.stock?.amount ?? 0, row?.amount),
                price: row?.stock?.price,
                originPrice: row?.stock?.originPrice,
                currency: row?.stock?.currency,
                image: row?.stock?.image,
                isDeleted: false,
                optionValues: row?.stock?.optionValues ?? [],
              },
            });
          } catch (error) {
            console.log("add post stock failed:", row?.code, error);
            _failed.push(row?.code);
          }
        }

        //* ລ້າງ cache ເທື່ອດຽວຫຼັງເພີ່ມຄົບ
        if (_added.length > 0) {
          await clearPostStockCache(_added[_added.length - 1]?.id);
          appendPostStocks(_added);
          addToast("ເພີ່ມສິນຄ້າ " + _added.length + " ລາຍການເຂົ້າໂພສສຳເລັດ!", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        if (_failed.length > 0) {
          addToast("ເພີ່ມບໍ່ສຳເລັດ: " + _failed.join(", "), {
            appearance: "error",
            autoDismiss: true,
          });
        }
        _warnings.forEach((message) =>
          addToast(message, { appearance: "warning", autoDismiss: true }),
        );

        setIsLoading(false);
        setIsSaving(false);
        //* ຍັງມີໂຕຫຼົ້ມ — ເປີດ modal ໄວ້ ຈະໄດ້ລອງໃໝ່ໄດ້ເລີຍ
        if (_failed.length === 0) {
          setShowAddStock(false);
          resetAddForm();
        } else {
          setAddRows((prev) =>
            (prev ?? []).filter((r) =>
              _failed.includes((r?.cfMessage ?? "").trim()),
            ),
          );
        }
        return;
      }

      //* ---- ສ້າງສິນຄ້າໃໝ່ແລ້ວປັກຂາຍເລີຍ ----
      if (selectedAddOption === "NEW") {
        const _code = (cfMessage ?? "").trim();
        const _name = (productTital ?? "").trim();
        const _price =
          parseFloat((stockPriceLak ?? "").toString().replace(/,/g, "")) || 0;
        const _amount =
          parseInt((stockAmount ?? "").toString().replace(/,/g, "")) || 0;

        if (!_name) {
          addToast("ກະລຸນາປ້ອນຊື່ສິນຄ້າ", {
            appearance: "warning",
            autoDismiss: true,
          });
          return;
        }
        const _check = checkCfCode(_code);
        if (_check.error) {
          addToast(_check.error, { appearance: "error", autoDismiss: true });
          return;
        }
        if (_price <= 0) {
          addToast("ກະລຸນາປ້ອນລາຄາ", {
            appearance: "warning",
            autoDismiss: true,
          });
          return;
        }
        if (_amount <= 0) {
          addToast("ກະລຸນາປ້ອນຈຳນວນ", {
            appearance: "warning",
            autoDismiss: true,
          });
          return;
        }

        setIsSaving(true);
        setIsLoading(true);

        await createProductAndStocks({
          variables: {
            data: {
              product: {
                price: _price,
                amount: _amount,
                title: _name,
                currency: currency ?? "",
                discount: 0,
              },
              stocks: [
                {
                  price: _price,
                  amount: _amount,
                  currency: currency ?? "",
                  name: _name,
                  cfMessage: _code,
                },
              ],
            },
            where: { shop: SHOP_ID },
          },
        });

        //* ດຶງ stock ທີ່ຫາກໍສ້າງ ເພື່ອເອົາ id ໄປຜູກກັບໂພສ
        //* ຫຼັງບ້ານຄົ້ນ cfMessage ແບບບາງສ່ວນ ຈຶ່ງຕ້ອງທຽບໃຫ້ຊື່ກັນແທ້ອີກຮອບ
        const _searchStock = await findStockByCf({
          variables: {
            where: { cfMessage: _code, shop: SHOP_ID, isDeleted: false },
            limit: 20,
            skip: 0,
            orderBy: "createdAt_DESC",
          },
        });
        const _newStock = (_searchStock?.data?.stocks?.data ?? []).find(
          (item) => normalizeCf(item?.cfMessage) === normalizeCf(_code),
        );
        if (!_newStock?.id) throw new Error("STOCK_NOT_FOUND_AFTER_CREATE");

        const _created = await createPostStock({
          variables: {
            data: {
              amount: _amount,
              amountAll: _amount,
              cfMessage: _code,
              cfCode: _code.toUpperCase(),
              stock: _newStock?.id,
              post: liveData?.id,
              fbFeedId: liveData?.fbFeedId,
              isPublished: true,
              isDeleted: false,
              shop: SHOP_ID,
            },
          },
        });

        const _newId = _created?.data?.createPostStock?.id;
        await clearPostStockCache(_newId);

        appendPostStocks([
          {
            id: _newId,
            amount: _amount,
            amountAll: _amount,
            cfMessage: _code,
            isPublished: true,
            createdAt: new Date(),
            fbFeedId: liveData?.fbFeedId,
            stock: {
              id: _newStock?.id,
              name: _newStock?.name ?? _name,
              amount: _newStock?.amount ?? _amount,
              price: _newStock?.price ?? _price,
              originPrice: _newStock?.originPrice,
              currency: _newStock?.currency ?? currency,
              image: _newStock?.image,
              isDeleted: false,
              optionValues: _newStock?.optionValues ?? [],
            },
          },
        ]);

        setShowAddStock(false);
        resetAddForm();
        addToast("ເພີ່ມ " + _code + " ເຂົ້າໂພສສຳເລັດ!", {
          appearance: "success",
          autoDismiss: true,
        });
        if (_check.warning) {
          addToast(_check.warning, {
            appearance: "warning",
            autoDismiss: true,
          });
        }
        setIsLoading(false);
        setIsSaving(false);
        return;
      }

      addToast("ກະລຸນາເລືອກວິທີເພີ່ມສິນຄ້າ", {
        appearance: "warning",
        autoDismiss: true,
      });
    } catch (error) {
      console.log("onAddStock error:", error);
      setIsLoading(false);
      setIsSaving(false);
      //* ບໍ່ປິດ modal ຕອນຜິດພາດ ຈະໄດ້ບໍ່ຕ້ອງພິມຂໍ້ມູນຄືນໃໝ່ໝົດ
      const _message = (error?.message ?? "").toString();
      if (_message.includes("CF_MESSAGE_ALREADY_EXISTS")) {
        addToast("ລະຫັດ CF ນີ້ມີໃນສາງຂອງຮ້ານແລ້ວ ໃຫ້ເລືອກຈາກສາງແທນ", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      addToast("ເພີ່ມສິນຄ້າບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const onSwitchStatus = async (data, index) => {
    let _postStocks = [...postStocks];
    updatePostStock({
      variables: {
        where: {
          id: data.id,
        },
        data: {
          isPublished: !data.isPublished,
        },
      },
    });

    _postStocks[index].isPublished = !data.isPublished;
    setPostStocks(_postStocks);
    if (!data.isPublished) {
      addToast("ລະຫັດ " + data?.cfMessage + " ຖືກປິດໃຊ້ງານແລ້ວ!", {
        appearance: "error",
        autoDismiss: true,
      });
    } else {
      addToast("ລະຫັດ " + data?.cfMessage + " ຖືກເປີດໃຊ້ງານແລ້ວ!", {
        appearance: "success",
        autoDismiss: true,
      });
    }
  };

  const onDelectPostStock = async () => {
    try {
      const _deletePostStock = await deletePostStock({
        variables: {
          where: {
            id: deleteData.id,
          },
        },
      });
      if (_deletePostStock?.data?.deletePostStock) {
        updateStock({
          variables: {
            where: {
              id: deleteData?.stock?.id,
            },
            data: {
              amount:
                (deleteData?.stock?.amount ?? 0) + (deleteData?.amount ?? 0),
              isUsing: false,
            },
          },
        });
      }
      let _postStocks = [...postStocks];
      _.remove(_postStocks, { id: deleteData?.id });
      setPostStocks(_postStocks);
      setShowDeleteModal(false);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const onChangeCfMesaage = (e) => {
    setCfMessage(e?.target?.value);
    const checkCfMessage = postStocks.filter(
      (item) => item.cfMessage == e?.target?.value,
    );
    if (checkCfMessage.length > 0) setIsAlreadyExist(true);
    else setIsAlreadyExist(false);
  };

  //* ເພີ່ມຈຳນວນສິນຄ້າໃນໂພສ
  //*
  //* amount = ຈຳນວນທີ່ຍັງເຫຼືອ (ຖືກຕັດເມື່ອລູກຄ້າ CF), amountAll = ຈຳນວນທັງໝົດ
  //* ການເພີ່ມຂອງຕ້ອງບວກທັງສອງຄ່າ ບໍ່ດັ່ງນັ້ນຕົວຫານຢູ່ໜ້າຈໍ (ເຫຼືອ/ທັງໝົດ) ຈະຜິດ
  const onEditAmount = async () => {
    try {
      const _add =
        parseFloat((amountAll ?? "").toString().replace(/,/g, "")) || 0;

      //* ບໍ່ໄດ້ພິມຫຍັງ ຫຼື ພິມ 0 — ອອກເສີຍໆ ບໍ່ຕ້ອງຍິງ API
      if (_add <= 0) {
        setShowEdit(false);
        setEditData(null);
        setAmountAll(null);
        return;
      }

      //* ກັນໄວ້ອີກຊັ້ນ ເຜື່ອຂອງໃນສາງຫຼຸດລົງລະຫວ່າງທີ່ເປີດຊ່ອງແກ້ໄຂຄ້າງໄວ້
      const _maxAdd = maxAddAmount(editData);
      if (_add > _maxAdd) {
        addToast(
          _maxAdd > 0
            ? "ເພີ່ມໄດ້ສູງສຸດ " + thousand(_maxAdd)
            : "ຂອງໃນສາງໝົດແລ້ວ ກະລຸນາເຕີມສາງກ່ອນ",
          {
            appearance: "warning",
            autoDismiss: true,
          },
        );
        return;
      }

      //* ເກັບໄວ້ກ່ອນ setEditData(null) ຂ້າງລຸ່ມ ຈະໄດ້ບໍ່ຕ້ອງອ່ານ state ທີ່ຖືກລ້າງແລ້ວ
      const _id = editData?.id;
      const _cfMessage = editData?.cfMessage ?? "";
      const _amount = (editData?.amount ?? 0) + _add;
      const _amountAll = (editData?.amountAll ?? 0) + _add;

      await updatePostStock({
        variables: {
          where: { id: _id },
          data: {
            amount: _amount >= 0 ? _amount : 0,
            amountAll: _amountAll,
          },
        },
      });

      //* ຕາໜ່າງກັນຊັ້ນສຸດທ້າຍ ປົກກະຕິບໍ່ເຂົ້າເງື່ອນໄຂນີ້
      //* ເພາະຊ່ອງປ້ອນຈຳກັດບໍ່ໃຫ້ເພີ່ມເກີນຂອງທີ່ມີໃນສາງຢູ່ແລ້ວ
      const _stockId = editData?.stock?.id;
      const _stockAmount = editData?.stock?.amount ?? 0;
      const _newStockAmount = Math.max(_stockAmount, _amount);
      if (_stockId && _stockAmount < _amount) {
        await updateStock({
          variables: {
            where: { id: _stockId },
            data: { amount: _amount },
          },
        });
      }

      //* ລ້າງ cache ຈະໄດ້ CF ຕິດທັນທີ ບໍ່ຕ້ອງລໍ cache ໝົດອາຍຸ
      await clearPostStockCache(_id);

      //* ອັບເດດຕົວເລກໜ້າຈໍທັນທີ ບໍ່ຕ້ອງລໍ refresh
      //*
      //* ຫາດ້ວຍ id ບໍ່ແມ່ນ editIndex ເພາະ index ນັ້ນເປັນຂອງ currentStocks
      //* (ຜ່ານການຄົ້ນຫາ + ແບ່ງໜ້າມາແລ້ວ) ຈຶ່ງບໍ່ຊີ້ໄປແຖວດຽວກັນກັບ postStocks
      //*
      //* ຫຸ້ມ try ຕ່າງຫາກ: ບັນທຶກລົງຖານຂໍ້ມູນສຳເລັດແລ້ວ ການແຕ້ມໜ້າຈໍບໍ່ໄດ້
      //* ຕ້ອງບໍ່ເຮັດໃຫ້ຂຶ້ນວ່າ "ບໍ່ສຳເລັດ" — ຢ່າງຫຼາຍກໍແຄ່ຕ້ອງ refresh ເອງ
      try {
        if (typeof setPostStocks === "function") {
          const _postStocks = [...(postStocks ?? [])];
          const _at = _postStocks.findIndex((x) => x?.id === _id);
          if (_at >= 0) {
            _postStocks[_at] = {
              ..._postStocks[_at],
              amount: _amount,
              amountAll: _amountAll,
              stock: {
                ..._postStocks[_at]?.stock,
                amount: _newStockAmount,
              },
            };
            setPostStocks(_postStocks);
          }
        }
      } catch (e) {
        console.log("refresh post stock list failed:", e);
      }

      setShowEdit(false);
      setEditData(null);
      setAmountAll(null); //* ລ້າງຊ່ອງ ກັນຄ່າຄ້າງໄປແຖວຕໍ່ໄປ

      addToast("ເພີ່ມຈຳນວນ " + _cfMessage + " ສຳເລັດ!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log(error);
      addToast("ເພີ່ມຈຳນວນບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  //* ເພີ່ມຈຳນວນເຂົ້າໂພສໄດ້ສູງສຸດເທົ່າໃດ = ຂອງໃນສາງ - ຂອງທີ່ຍັງເຫຼືອໃນໂພສ
  //*
  //* ຕອນລູກຄ້າ CF ລະບົບຕັດສະຕັອກ 2 ບ່ອນ ຄື ໃນໂພສ ແລະ ໃນສາງ
  //* ຖ້າໃຫ້ຈຳນວນໃນໂພສຫຼາຍກວ່າສາງ CF ຈະຈັບລະຫັດໄດ້ ແຕ່ຕັດສະຕັອກບໍ່ຜ່ານ ອໍເດີກໍຫຼຸດ
  const maxAddAmount = (postStock) =>
    Math.max(0, (postStock?.stock?.amount ?? 0) - (postStock?.amount ?? 0));

  const thousand = (num) =>
    num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";

  const indexOfLastStock = currentPage * stocksPerPage;
  const indexOfFirstStock = indexOfLastStock - stocksPerPage;
  const currentStocks = displayPostStocks.slice(
    indexOfFirstStock,
    indexOfLastStock,
  );

  return (
    <div>
      {/* {isLoading ? <AnimationLoading /> : <div />} */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "8px 8px 8px 8px",
        }}
      >
        <p style={{ fontSize: 20, margin: 0 }}>
          ລາຍການສິນຄ້າທີ່ເພີ່ມເຂົ້າໃນໂພສ ({displayPostStocks?.length ?? 0})
        </p>

        {/* ຊ່ອງຄົ້ນຫາ ກັບ ປຸ່ມເພີ່ມສິນຄ້າ ຢູ່ແຖວດຽວກັນ
         * ຈໍນ້ອຍໃຫ້ປຸ່ມຕົກລົງແຖວໃໝ່ ບໍ່ດັ່ງນັ້ນຈະໄປບີບຊ່ອງຄົ້ນຫາຈົນພິມບໍ່ໄດ້
         */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: width > 700 ? "nowrap" : "wrap",
            gap: 12,
          }}
        >
          <Form.Control
            // className="mb-2 mx-2"
            style={{ flex: 1, minWidth: 220 }}
            type="text"
            name="searchKeyWord"
            placeholder="ຄົ້ນຫາຕາມຊື່ສິນຄ້າ ຫລື ລະຫັດ CF..."
            value={searchKeyWord}
            onChange={(e) => setSearchKeyWord(e.target.value)}
          />

          {/* add product */}
          <button
            className="btn hoverme"
            style={{
              background: COLOR_APP,
              borderColor: COLOR_APP,
              color: "#fff",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
            onClick={() => {
              resetAddForm();
              setSeletedAddOption("ON_STOCK");
              setShowAddStock(true);
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> ເພີ່ມສິນຄ້າເຂົ້າໂພສ
          </button>
        </div>
      </div>

      <div>
        <Table responsive className="staff-table-list borderless table-hover">
          <thead style={{ background: "#F1F1F1", whiteSpace: "nowrap" }}>
            <tr>
              <th style={{ width: 35, borderBottom: "none" }}>ລຳດັບ</th>
              <th style={{ borderBottom: "none" }}>ຮູບ</th>
              <th style={{ width: 50, borderBottom: "none" }}>ສິນຄ້າ</th>
              <th style={{ borderBottom: "none" }}>ລະຫັດ CF</th>
              <th style={{ borderBottom: "none" }}>ລາຄາ</th>
              <th style={{ width: 180, borderBottom: "none" }}>ຈຳນວນ</th>
              <th style={{ width: 130, borderBottom: "none" }}>ສະຖານະ</th>
              <th style={{ width: 200, borderBottom: "none" }}>ເວລາ</th>
              <th style={{ width: 130, borderBottom: "none" }}>ຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            {currentStocks?.length > 0 &&
              currentStocks?.map((data, index) => (
                <tr key={index} style={{ whiteSpace: "nowrap" }}>
                  <td style={{ width: 35 }}>
                    {stocksPerPage * (currentPage - 1) + index + 1}
                  </td>
                  <td style={{ width: 50 }}>
                    <img
                      src={imageRender(data?.stock?.image ?? "")}
                      style={{
                        borderRadius: "10%",
                        cursor: "pointer",
                        height: 40,
                        width: 40,
                      }}
                    />
                  </td>
                  <td>
                    <div>
                      {data?.stock?.name || "ຍັງບໍ່ກໍານົດ"}
                      {data?.stock?.optionValues.length > 0 &&
                        data?.stock?.optionValues?.map(
                          (optionvalue, optionvalueIndex) => (
                            <span key={optionvalueIndex}>
                              {" \t "} {optionvalue?.value}{" "}
                            </span>
                          ),
                        )}
                    </div>
                  </td>
                  <td>{data?.cfMessage ?? ""}</td>
                  <td>
                    {data?.stock?.price
                      ? new Intl.NumberFormat("en-US").format(
                          data?.stock?.price ?? 0,
                        )
                      : "-"}{" "}
                    {data?.stock?.currency ?? ""}
                  </td>
                  <td style={{ width: 180 }}>
                    {showEdit && editData?.id == data?.id ? (
                      <span style={{ marginTop: 5 }}>ເພີ່ມ:</span>
                    ) : (
                      <span>ເຫຼືອ:</span>
                    )}{" "}
                    {showEdit && editData?.id == data?.id ? (
                      <NumberFormat
                        name="amountAll"
                        className="form-control"
                        onChange={(e) => {
                          const _max = maxAddAmount(data);
                          const _value =
                            parseInt(
                              (e?.target?.value ?? "")
                                .toString()
                                .replace(/,/g, ""),
                            ) || 0;

                          //* ປ້ອນເກີນ — ປັບລົງໃຫ້ເທົ່າທີ່ເພີ່ມໄດ້ ບໍ່ແມ່ນປະຕິເສດການພິມ
                          if (_value > _max) {
                            setAmountAll(_max.toString());
                            addToast(
                              _max > 0
                                ? "ເພີ່ມໄດ້ສູງສຸດ " + thousand(_max)
                                : "ຂອງໃນສາງໝົດແລ້ວ ກະລຸນາເຕີມສາງກ່ອນ",
                              {
                                appearance: "warning",
                                autoDismiss: true,
                              },
                            );
                            return;
                          }

                          setAmountAll(e?.target?.value ?? "");
                        }}
                        value={amountAll ?? ""}
                        placeholder={"ສູງສຸດ " + thousand(maxAddAmount(data))}
                        styles={{ width: 180 }}
                        thousandSeparator={true}
                        prefix={""}
                      />
                    ) : (
                      <span>
                        {thousand(data?.amount > 0 ? data?.amount : 0)} {" / "}{" "}
                        {thousand(data?.amountAll > 0 ? data?.amountAll : 0)}
                      </span>
                    )}
                    {/* {data?.amount ? new Intl.NumberFormat('en-US').format(data?.amount ?? 0) : "0"} / {data?.amountAll ? new Intl.NumberFormat('en-US').format(data?.amountAll ?? 0) : "0"} */}

                    {/* ຈຳນວນໃນສາງກາງ
                     * ຕອນລູກຄ້າ CF ລະບົບຕັດສະຕັອກ 2 ບ່ອນ ຄື ໃນໂພສ ແລະ ໃນສາງ
                     * ຖ້າສາງເປັນ 0 ເຖິງວ່າໃນໂພສຍັງເຫຼືອ CF ກໍຈະບໍ່ຕິດ ຈຶ່ງຕ້ອງເຫັນໄດ້ຢູ່ນີ້
                     */}
                    <div>
                      <small
                        style={{
                          color:
                            (data?.stock?.amount ?? 0) <= 0 ? "red" : "#888",
                        }}
                      >
                        ໃນສາງ: {thousand(data?.stock?.amount)}
                      </small>
                    </div>
                  </td>
                  <td style={{ width: 130 }}>
                    <Switch
                      checked={data.isPublished ?? false}
                      onChange={() => onSwitchStatus(data, index)}
                      onColor="#bfbdc7"
                      onHandleColor="#422f90"
                      handleDiameter={30}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch"
                      id="material-switch"
                    />
                  </td>
                  <td style={{ width: 200 }}>
                    {moment(data?.createdAt).format("DD/MM/YYYY HH:mm A")}
                  </td>
                  {editData?.id != data?.id && (
                    <td style={{ width: 130 }}>
                      <button
                        className="btn hoverme"
                        onClick={() => {
                          setEditData(data);
                          setEditIndex(index);
                          setShowEdit(true);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          style={{ color: COLOR_APP }}
                        />
                      </button>
                      <button
                        className="btn hoverme"
                        onClick={() => {
                          setDeleteData(data);
                          setShowDeleteModal(true);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          style={{ color: "red" }}
                        />
                      </button>
                    </td>
                  )}
                  {showEdit && editData?.id == data?.id && (
                    <td style={{ width: 130 }}>
                      <button
                        className="btn hoverme align-self-start"
                        onClick={() => onEditAmount()}
                        style={{
                          borderColor: COLOR_APP,
                          color: COLOR_APP,
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faSave}
                          style={{ borderColor: COLOR_APP, color: COLOR_APP }}
                        />{" "}
                        ບັນທຶກ
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
        {totalPages > 1 && currentStocks.length > 0 && (
          <ReactPaginate
            previousLabel="ກັບຄືນ"
            onPageChange={handlePageClick}
            breakLabel="..."
            pageRangeDisplayed={5}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            renderOnZeroPageCount={null}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
            forcePage={pageNumber - 1}
            nextLabel="ຕໍ່ໄປ"
          />
        )}
      </div>

      {/* ເພີ່ມສິນຄ້າເຂົ້າໂພສ */}
      {/* ບໍ່ໃສ່ scrollable — CSS bootstrap 4 ຈະເຮັດໃຫ້ modal ຢືດເຕັມຄວາມສູງຈໍ
       * ຈົນເກີດພື້ນທີ່ຫວ່າງໃຫຍ່ຢູ່ລຸ່ມປຸ່ມ ລາຍການສິນຄ້າມີ scroll ຂອງໂຕເອງແລ້ວ
       */}
      <Modal
        show={showAddStock}
        size="lg"
        centered
        onHide={() => {
          if (isSaving) return;
          setShowAddStock(false);
          resetAddForm();
        }}
      >
        <Modal.Header closeButton>
          <div>ເພີ່ມສິນຄ້າເຂົ້າໂພສນີ້</div>
        </Modal.Header>
        <Modal.Body style={{ padding: 20 }}>
          <ButtonGroup className="mb-3">
            <Button
              style={{
                background: selectedAddOption === "ON_STOCK" ? COLOR_APP : "#eee",
                color: selectedAddOption === "ON_STOCK" ? "#fff" : "#000",
                width: 160,
                borderWidth: 0,
              }}
              onClick={() => setSeletedAddOption("ON_STOCK")}
            >
              ເລືອກຈາກສາງ
            </Button>
            <Button
              style={{
                background: selectedAddOption === "NEW" ? COLOR_APP : "#eee",
                color: selectedAddOption === "NEW" ? "#fff" : "#000",
                width: 160,
                marginLeft: 12,
                borderWidth: 0,
              }}
              onClick={() => setSeletedAddOption("NEW")}
            >
              ສ້າງສິນຄ້າໃໝ່
            </Button>
          </ButtonGroup>

          {selectedAddOption === "ON_STOCK" && (
            <div>
              <Form.Control
                type="text"
                placeholder="ຄົ້ນຫາຊື່ສິນຄ້າ ຫຼື ລະຫັດ CF ໃນສາງ..."
                value={stockKeyWord}
                onChange={(e) => setStockKeyWord(e.target.value)}
              />
              <div
                style={{
                  maxHeight: 280,
                  overflowY: "auto",
                  marginTop: 8,
                  border: "1px solid #eee",
                  borderRadius: 6,
                }}
              >
                {stockLoading && <div style={{ padding: 12 }}>ກຳລັງໂຫຼດ...</div>}
                {!stockLoading && (stocksData?.length ?? 0) === 0 && (
                  <div style={{ padding: 12, color: "#888" }}>ບໍ່ພົບສິນຄ້າ</div>
                )}
                {stocksData?.map((item, index) => {
                  const _isChecked = (addRows ?? []).some(
                    (row) => row?.stock?.id === item?.id,
                  );
                  //* ທີ່ມີໃນໂພສແລ້ວ ຕິກບໍ່ໄດ້ ກັນລະຫັດ CF ຊ້ຳ
                  //* ໂຕທີ່ຍັງບໍ່ມີລະຫັດ ບໍ່ນັບວ່າຊ້ຳ ເພາະຄ່າຫວ່າງທຽບກັນໄດ້ໝົດ
                  const _code = normalizeCf(item?.cfMessage);
                  const _isAdded =
                    !!_code &&
                    (postStocks ?? []).some(
                      (p) => normalizeCf(p?.cfMessage) === _code,
                    );
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        if (_isAdded) return;
                        toggleStockRow(item);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: 8,
                        cursor: _isAdded ? "not-allowed" : "pointer",
                        background: _isChecked ? "#f1efff" : "#fff",
                        opacity: _isAdded ? 0.45 : 1,
                        borderBottom: "1px solid #f4f4f4",
                      }}
                    >
                      {/* ໃຊ້ input ທຳມະດາ ບໍ່ໃຊ້ Form.Check
                       *
                       * ໂປຣເຈັກນີ້ໂຫຼດ CSS ຂອງ bootstrap 4 ແຕ່ react-bootstrap ເປັນລຸ້ນ 2
                       * ເມື່ອບໍ່ໄດ້ໃສ່ label ມັນຈະບໍ່ຫຸ້ມດ້ວຍ div .form-check ທີ່ເປັນ
                       * position:relative ຊ່ອງຕິກທີ່ເປັນ position:absolute ຈຶ່ງຫຼຸດອອກ
                       * ໄປວາງນອກ modal
                       *
                       * ການຕິກປ່ອຍໃຫ້ຄລິກຂອງແຖວເປັນຄົນຈັດການ ຈະໄດ້ບໍ່ສະຫຼັບສອງເທື່ອ
                       */}
                      <input
                        type="checkbox"
                        checked={_isChecked}
                        disabled={_isAdded}
                        onChange={() => {}}
                        style={{
                          position: "static",
                          margin: 0,
                          height: 16,
                          width: 16,
                          flexShrink: 0,
                          cursor: _isAdded ? "not-allowed" : "pointer",
                        }}
                      />
                      <img
                        src={imageRender(item?.image ?? "")}
                        style={{ height: 36, width: 36, borderRadius: "10%" }}
                      />
                      <div style={{ flex: 1 }}>
                        <div>{item?.name || "-"}</div>
                        <small style={{ color: "#888" }}>
                          ລະຫັດ: {item?.cfMessage || "-"} | ໃນສາງ:{" "}
                          {thousand(item?.amount)} |{" "}
                          {new Intl.NumberFormat("en-US").format(
                            item?.price ?? 0,
                          )}{" "}
                          {item?.currency ?? ""}
                        </small>
                      </div>
                      {_isAdded && (
                        <small style={{ color: "red" }}>ມີໃນໂພສແລ້ວ</small>
                      )}
                    </div>
                  );
                })}
              </div>

              {(addRows?.length ?? 0) > 0 && (
                <div style={{ marginTop: 14 }}>
                  <div style={{ marginBottom: 6 }}>
                    ເລືອກແລ້ວ {addRows.length} ລາຍການ — ກຳນົດລະຫັດ CF ແລະ
                    ຈຳນວນທີ່ຈະຂາຍ
                  </div>
                  <div
                    style={{
                      maxHeight: 260,
                      overflowY: "auto",
                      border: "1px solid #eee",
                      borderRadius: 6,
                    }}
                  >
                    {addRows.map((row, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          padding: 8,
                          borderBottom: "1px solid #f4f4f4",
                          flexWrap: width > 700 ? "nowrap" : "wrap",
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 140 }}>
                          <div>{row?.stock?.name || "-"}</div>
                          <small style={{ color: "#888" }}>
                            ໃນສາງ: {thousand(row?.stock?.amount)}
                          </small>
                        </div>
                        <Form.Control
                          type="text"
                          style={{ width: 130 }}
                          placeholder="ລະຫັດ CF"
                          value={row?.cfMessage ?? ""}
                          onChange={(e) =>
                            updateAddRow(row?.stock?.id, {
                              cfMessage: e.target.value,
                            })
                          }
                        />
                        <NumberFormat
                          className="form-control"
                          style={{ width: 110 }}
                          value={row?.amount ?? ""}
                          onChange={(e) => {
                            const _max = row?.stock?.amount ?? 0;
                            const _value =
                              parseInt(
                                (e?.target?.value ?? "")
                                  .toString()
                                  .replace(/,/g, ""),
                              ) || 0;

                            //* ປ້ອນເກີນຂອງທີ່ມີ — ປັບລົງໃຫ້ເທົ່າຂອງທີ່ມີ
                            //* ບໍ່ແມ່ນປະຕິເສດການພິມ ຈະໄດ້ບໍ່ຕ້ອງລຶບພິມຄືນໃໝ່
                            if (_value > _max) {
                              updateAddRow(row?.stock?.id, {
                                amount: _max.toString(),
                              });
                              addToast(
                                (row?.stock?.name ?? "") +
                                  " ມີພຽງ " +
                                  thousand(_max),
                                {
                                  appearance: "warning",
                                  autoDismiss: true,
                                },
                              );
                              return;
                            }

                            updateAddRow(row?.stock?.id, {
                              amount: e?.target?.value ?? "",
                            });
                          }}
                          placeholder="ຈຳນວນ"
                          thousandSeparator={true}
                          prefix={""}
                        />
                        <button
                          className="btn hoverme"
                          onClick={() => toggleStockRow(row?.stock)}
                        >
                          <FontAwesomeIcon
                            icon={faTimes}
                            style={{ color: "red" }}
                          />
                        </button>
                      </div>
                    ))}
                  </div>
                  <small style={{ color: "#888" }}>
                    ປ້ອນໄດ້ສູງສຸດເທົ່າຈຳນວນທີ່ມີໃນສາງ
                  </small>
                </div>
              )}
            </div>
          )}

          {selectedAddOption === "NEW" && (
            <div>
              <Form.Group className="mb-2">
                <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ຊື່ສິນຄ້າ"
                  value={productTital}
                  onChange={(e) => setProductTital(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>ລະຫັດ CF</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ຕົວຢ່າງ: A1"
                  value={cfMessage}
                  onChange={(e) => onChangeCfMesaage(e)}
                />
                {isAlreadyExist && (
                  <small style={{ color: "red" }}>
                    ລະຫັດ CF ນີ້ມີຢູ່ໃນໂພສນີ້ແລ້ວ
                  </small>
                )}
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>ລາຄາ</Form.Label>
                <NumberFormat
                  className="form-control"
                  value={stockPriceLak ?? ""}
                  onChange={(e) => setStockPriceLak(e?.target?.value ?? "")}
                  placeholder="0"
                  thousandSeparator={true}
                  prefix={""}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>ຈຳນວນ</Form.Label>
                <NumberFormat
                  className="form-control"
                  value={stockAmount ?? ""}
                  onChange={(e) => setStockAmount(e?.target?.value ?? "")}
                  placeholder="0"
                  thousandSeparator={true}
                  prefix={""}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>ສະກຸນເງິນ</Form.Label>
                <div>
                  <ButtonGroup>
                    {["ກີບ", "ບາດ", "ໂດລາ"].map((item, index) => (
                      <Button
                        key={index}
                        style={{
                          background: currency === item ? COLOR_APP : "#eee",
                          color: currency === item ? "#fff" : "#000",
                          width: 100,
                          marginLeft: index === 0 ? 0 : 12,
                          borderWidth: 0,
                        }}
                        onClick={() => setCurrency(item)}
                      >
                        {item}
                      </Button>
                    ))}
                  </ButtonGroup>
                </div>
              </Form.Group>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            flexDirection: width > 700 ? "row" : "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="outline-dark"
            className="btn btn-app hoverme"
            style={{ width: 150 }}
            disabled={isSaving}
            onClick={() => {
              setShowAddStock(false);
              resetAddForm();
            }}
          >
            ຍົກເລີກ
          </Button>
          <div style={{ width: 24 }} />
          <button
            className="btn btn-app hoverme"
            style={{ background: COLOR_APP, color: "#fff", width: 150 }}
            disabled={isSaving}
            onClick={() => onAddStock()}
          >
            {isSaving ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <div>ຢືນຢັນການລຶບ</div>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: 24,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationCircle}
            style={{ fontSize: 90, color: "orange" }}
          />
          <br />
          <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບ ສິນຄ້າອອກຈາກ Post ນີ້ແທ້ບໍ່?</h5>
        </Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            flexDirection: width > 700 ? "row" : "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="outline-dark"
            className="btn btn-app hoverme"
            style={{ width: 150 }}
            onClick={() => setShowDeleteModal(false)}
          >
            ກັບຄືນ
          </Button>
          <div style={{ width: 24 }} />
          <button
            className="btn btn-app hoverme"
            style={{
              float: "left",
              background: "red",
              color: "#fff",
              width: 150,
            }}
            onClick={() => onDelectPostStock()}
          >
            ລຶບ
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default LiveDetailPostProduct;
